/**
 * カスタムArrayのベースクラス
 */

export class CustomArray<T> extends Array<T> {
  // コンストラクタで初期アイテム配列を受け取り、存在しなければ空配列で初期化する
  constructor(initialItems: T[] = []) {
    if (typeof initialItems === "number") {
      // 数値の場合はそのままスーパークラスのコンストラクタに渡す
      super(initialItems);
    } else {
      // 配列の場合は展開して渡す
      super(...initialItems);
    }
    // ES5 環境などで正しくプロトタイプチェーンを設定するための補正
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
